import * as React from "react"
import { cn } from "../../lib/utils"
import { Card, CardContent, CardHeader } from "./card"

const StatCard = React.forwardRef(({ 
  className, 
  title, 
  value, 
  description,
  icon: Icon,
  trend,
  ...props 
}, ref) => (
  <Card ref={ref} className={cn("h-full", className)} {...props}>
    <div className="p-1 h-full flex items-center justify-between">
      <div className="flex flex-col flex-1 min-w-0">
        <h3 className="text-xs font-medium truncate leading-tight">
          {title}
        </h3>
        <div className="text-lg font-bold leading-none">{value}</div>
      </div>
      <div className="flex flex-col items-center ml-1">
        {Icon && (
          <Icon className="h-3 w-3 text-muted-foreground" />
        )}
        {trend && (
          <div className={cn(
            "text-xs font-medium leading-none",
            trend.type === 'positive' ? 'text-emerald-600' : 
            trend.type === 'negative' ? 'text-red-600' : 
            'text-muted-foreground'
          )}>
            {trend.type === 'positive' ? '+' : trend.type === 'negative' ? '-' : ''}
          </div>
        )}
      </div>
    </div>
  </Card>
))
StatCard.displayName = "StatCard"

export { StatCard } 